import styled from 'styled-components';
import { aiStack } from '../../../contants';
import { motion } from 'framer-motion';
import { useTheme } from '../../../context/ThemeContext';

const AITile = () => {
  const { isDarkMode } = useTheme();
  return (
    <Wrapper>
      <ContentWrapper>
        <Header>The AI Stack</Header>
        <Content>
          {aiStack.map((app, index) => (
            <Box
              isDarkMode={isDarkMode}
              key={index}
              as={motion.div}
              whileHover={{ scale: 1.1 }}
            >
              <a href={app.link}>
                <Logo src={app.logo} />
              </a>
            </Box>
          ))}
        </Content>
      </ContentWrapper>
    </Wrapper>
  );
};

const Logo = styled.img`
  max-height: 100px;
  max-width: 100px;
  padding: 6px;
  @media (max-width: 500px) {
    max-height: 60px;
    width: 80%;
    padding: 0px 4px;
  }
`;

const Wrapper = styled.div`
  position: relative;
  height: 100%;
  border-radius: 30px;
`;
const ContentWrapper = styled.div`
  position: absolute;
  padding: 20px 36px;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  @media (max-width: 500px) {
    padding: 12px 2px;
  }
`;
const Header = styled.div`
  margin-bottom: 8px;
  line-height: 32px;
  font-size: 24px;
  font-weight: 800;
  @media (max-width: 500px) {
    font-size: 20px;
    line-height: 24px;
  }
`;

const Content = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  @media (max-width: 500px) {
    height: fit-content;
    padding: 2px 18px;
  }
`;

const Box = styled.div`
  background-color: ${({ theme, isDarkMode }) =>
    isDarkMode ? 'transparent' : theme.tileBackground};
  flex: 1 1 calc(50% - 8px);
  border-radius: 24px;
  overflow: hidden;
  @media (max-width: 500px) {
    border-radius: 18px;
  }
`;

export default AITile;
